




































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Inject } from "vue-property-decorator";
import { ISelectListItem, IUserModel, RoleEnum } from "../models";
import { RestResponse } from "@elite/restclient";
import { RestClient } from "@elite/restclient";
import { UserRoute } from "../router";
import IView from "./IView";
import { ModelState } from "@elite/validation";

@Component
export default class AddEditUser extends Vue implements IView {
    @Prop({ required: true })
    title!: string;

    @Inject()
    restClient!: RestClient;

    @Inject()
    modelState!: ModelState;

    @Prop({ type: Number, default: null })
    id?: number;

    roleItems: ISelectListItem[] = this.$store.state.roleItems;
    isLoading = false;
    model: IUserModel | null = null;

    // the role computed property is used to transform the model.role (RoleEnum - number) to a string,
    // the options values for the role dropdown are strings so we need to match the type of the model.role property
    // we can't use model.number for role because the val-form-input uses the v-select component instead of the select
    get role(): string | undefined {
        return this.model?.role?.toString();
    }
    // this is to transform back to the original type, needed when we send this value to the backend
    set role(val: string | undefined) {
        if (this.model?.role && val) {
            this.model.role = Number(val) as RoleEnum;
        }
    }

    mounted() {
        this.modelState.clear(this);
        this.refreshModel();
    }

    async refreshModel() {
        if (this.id) {
            const response = await this.restClient.getJson<IUserModel>(
                "/api/User/" + this.id
            );

            if (response.status == 200 && response.data) {
                this.model = response.data;
            }
        } else {
            this.model = {
                id: 0,
                firstName: null,
                lastName: null,
                emailAddress: null,
                password: null,
                confirmPassword: null,
                role: this.$store.state.roleValues?.administrator
            };
        }
    }

    async save() {
        if (!this.model) {
            return;
        }

        // if the user enters anything into a field (or a password helper extension autofills), and then it's deleted,
        // the value will change from null to empty, so the server side compare validator will fail
        if (this.model.password === "") {
            this.model.password = null;
        }

        if (this.model.confirmPassword === "") {
            this.model.confirmPassword = null;
        }

        this.isLoading = true;

        let response: RestResponse<IUserModel>;

        const apiLocation = "/api/User";

        if (this.model.id && this.model.id > 0) {
            response = await this.restClient.putJson<IUserModel>(
                apiLocation,
                this.model
            );
        } else {
            response = await this.restClient.postJson<IUserModel>(
                apiLocation,
                this.model
            );
        }

        if (this.modelState.hasErrors(response) || !response.data) {
            this.modelState.addResponseErrors(response, this);
        } else {
            this.$router.push({
                path: UserRoute.path
            });
        }

        this.isLoading = false;
    }
}
